export const parseCoordinates = (value: string): [number, number] | null => {
  const match = /^(-?\d+.?\d{0,})\s*,\s*(-?\d+.?\d{0,})$/.exec(value.trim());

  if (!match) return null;

  const lng = parseFloat(match[1]);
  const lat = parseFloat(match[2]);

  // check range
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;

  return [lng, lat];
};
